// "Show All" / "Collapse All" for a set of <details> panels.
// Markup: a container with data-accordion-group holding buttons with
// data-accordion-action="open" or "close" and the <details> elements.
export default function initAccordionGroups() {
	document.querySelectorAll("[data-accordion-group]").forEach((group) => {
		group.querySelectorAll("[data-accordion-action]").forEach((button) => {
			button.addEventListener("click", () => {
				const open = button.dataset.accordionAction === "open";
				group.querySelectorAll("details").forEach((panel) => { panel.open = open; });
			});
		});
	});
}
